module.exports = __webpack_public_path__ + "static/wallers-ba9a844643f5aefdaa85d2395f0de419.mp4";